import { AfterViewInit, Component } from '@angular/core';
import maplibregl, { Marker, Popup } from 'maplibre-gl';
import { ApiService } from '../services/contratos/contratos.service';
import { AppModule } from '../app.module';
import { Subject, interval } from 'rxjs';
import { Observable, fromEvent } from 'rxjs';
import { catchError, distinctUntilChanged, map } from 'rxjs/operators';
import supercluster, { PointFeature } from 'supercluster';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';

@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.css'],
  standalone: false
})
export class TrackingComponent {
  // apiKey = "v1.public.eyJqdGkiOiJiZjA5NjY4MS1lNjBlLTQ3NjEtODE1NS04MTA3N2VlMWNiNTEifTeO-jM5cgo2q0aCF5-5CtyFzHJCmiVFTtMvb63TqPuCgRHzgAp4fToOmh0qi5GP6zsNF3cyXkeoOiwBfyDC4zsU6QO-xzjHHzG3tZ19VBwVDnE49556GGEsA-nkfhLgM64WzpJNt_v2C8sZfbl_Pr4EabQDnz8--1r6pe4qcbN4wwpZetb6RxwGfjIkSxSLshpqGCvUSISrzS3jrxhOkp_mbOBx-L8jumjc8YT3NTsmvPS0sdEGmDk5516PX4wRBwHR_Ry2wlbbfq-gH5AMkNZb28KhyVVGezJ3HNhV32FlOPfrbmEovAa-s2DOUZBR00MkZW8wIPgpter9ihwFs5c.ZTA0NDFlODYtNGY5Mi00NWU4LTk1MDgtMmY4YmViYWFhYjUz";
  // mapName = "Tracking_Karrara_Claro";
  apiKey = "v1.public.eyJqdGkiOiI5YWE5M2IzZC04YzJiLTRmN2EtOTdiZi1lM2U4Y2VjZDdlNmMifY-CsFf09lpFoqmfVP5RNrfgBujnc_10Dj3L6UNokoG7iIfIc-atKXyTtGjsvFjyTvTZucDqshFuaQwjiqpJcYurZiZSljynClRnFynKcqOayP-7aq8syTBj7xHbbRkRq5DbWrLpXdYQK6-E_OBdEGDE89wT7S6pFHUSOdWzuBcXrTeA7OemFI5SIoD5JuLzHZzLsWcTmfvfzNCWMvS2VN57fpAu5yWLEilBpc3CYB1oiQmsLix8ugGlxSWx6RdoV6ZpyfqwgB0NbUKT2GJUKK8RB8s1pebBZF_0n7_rwMkGqmxgXgZT1g7xXsWI5O__wf9HjAxCsi05r5-JeyZTDqQ.ZTA0NDFlODYtNGY5Mi00NWU4LTk1MDgtMmY4YmViYWFhYjUz";
  mapName = "e-transportMap";
  region = "sa-east-1";
  markerImagePath!: string;
  // markerImagePath: string = 'assets/truck.png';
  // markerImagePathVerde: string = 'assets/truckVerde.png';
  posicao!: any[];
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  urlConsultaCompactada: string = 'https://q9hhz5wjah.execute-api.sa-east-1.amazonaws.com/volumeGD';
  urlConsultaComFiltroNovo: string = 'https://se468a0eif.execute-api.sa-east-1.amazonaws.com/v1';
  queryInterplantas: string = 'Operacao_Interplantas_Karrara';
  query: string = 'Operacao_Interplantas_Karrara';
  query2: string = 'positionLOTS';
  query3: string = 'Itens_Jetta';
  query4: string = 'Porta_Rastreando_JSL';
  query5: string = 'items_Excel_Karrara';
  queryFornecedores: string = 'Fornecedores_Karrara_Transport';
  placaFiltrada!: string;
  posicaoSul!: any[];
  posicaoSulRastreio!: any[];
  filtro: boolean = false;
  subscription: any;
  private placaFiltradaSubject = new Subject<string>();
  posicaoLOTS!: any[];
  posicaoArg!: any[];
  posicaoArgRastreio!: any[];
  isLoading: boolean = true;
  usuarioLogado: any;
  maiorHorarioJanela!: number;
  carros!: any[];
  markers!: maplibregl.Marker[];
  map: any;
  cluster!: supercluster<supercluster.AnyProps, supercluster.AnyProps>;
  index: number = 0;
  filterColumn: string = 'date';
  referenceDate!: string;
  numDays: number = 5;
  queryContainers: string = 'items_Excel_Container';
  containers!: any[];
  carrosVerdes: number = 0;
  carrosVermelhos: number = 0;
  verVerdes: boolean = true;
  verVermelhos: boolean = true;
  verSUZAN: boolean = true;
  verLOTS: boolean = true;
  verSemSinal: boolean = true;
  verComSinal: boolean = true;
  verJSLARG: boolean = true;
  verJSL: boolean = true;
  verTCM: boolean = true;
  verSESE: boolean = true;
  verLocais: boolean = true;
  itemEditado: any;
  dialogOpen: boolean = false;
  item: any;
  edit2: boolean = false;
  fornecedores!: any[];
  marcadores: any[] = [];
  verNomeLocais: boolean = true;
  locais!: any[];
  carrosComSinal: number = 0;
  containersEXP!: any[];
  DataAtual!: Date;
  carrosSemSinal: number = 0;
  markerImageSinal!: string;


  constructor(
    private dynamodbService: ApiService,
    private servicoAutenticacao: AutenticacaoService,
  ) {
    this.placaFiltrada = '';
  }


  markerCoordinates: [number, number][] = [];

  async ngOnInit(): Promise<void> {
    this.markers = [];
    this.map = new maplibregl.Map({
      container: "map",
      style: `https://maps.geo.${this.region}.amazonaws.com/maps/v0/maps/${this.mapName}/style-descriptor?key=${this.apiKey}`,
      center: [-46.56665783189564, -23.712571371830165],
      zoom: 12,
      transformRequest: (url, resourceType) => {
        if (url.startsWith("https://api.mapbox.com")) {
          // Adicione a chave de acesso como parâmetro na URL da requisição
          url += "&access_token=" + this.apiKey;
        }
        return { url };
      }
    });
    this.cluster = new supercluster({
      radius: 40, // O raio de agrupamento (em pixels)
      maxZoom: 10, // O zoom máximo em que os agrupamentos serão ativados
    });
    await this.getLocais();
    await this.getUserLogado();
    await this.getPosicaoFromDynamoDB();
    await this.getContainers();
    await this.getContainersEXP();
    this.containers = this.containers.concat(this.containersEXP);
    // console.log(this.posicao)
    await this.getPosicaoMilkSulFromDynamoDB();
    await this.getPosicaoMilkRastreioFromDynamoDB();
    await this.getPosicaoLOTSFromDynamoDB();
    await this.getPosicaoMilkArgFromDynamoDB();
    await this.getFornecedoresFromDynamoDB();
    await this.compareAndMergePlates();
    await this.compareAndMergePlatesArg();
    await this.compareAndMergePlatesLOTS();
    await this.compareAndMergePlatesLOTSContainers();
    await this.inicia();
    this.isLoading = false;

    this.subscription = interval(3 * 60 * 1000).subscribe(async () => {
      //console.log("atualizou")
      // await this.getPosicaoFromDynamoDB();
      // await this.getPosicaoMilkSulFromDynamoDB();
      // await this.getContainers();
      // await this.getPosicaoMilkRastreioFromDynamoDB();
      // await this.getPosicaoLOTSFromDynamoDB();
      // await this.getPosicaoMilkArgFromDynamoDB();
      // await this.compareAndMergePlatesLOTS();
      // await this.compareAndMergePlatesLOTSContainers();
      // await this.compareAndMergePlates();
      // await this.compareAndMergePlatesArg();
      // await this.inicia();
      await this.update();
    });
  }

  async update() {
    await this.getPosicaoFromDynamoDB();
    await this.getLocais();
    await this.getPosicaoMilkSulFromDynamoDB();
    await this.getContainers();
    await this.getContainersEXP();
    await this.getPosicaoMilkRastreioFromDynamoDB();
    await this.getPosicaoLOTSFromDynamoDB();
    await this.getPosicaoMilkArgFromDynamoDB();
    await this.compareAndMergePlatesLOTS();
    await this.compareAndMergePlatesLOTSContainers();
    await this.compareAndMergePlates();
    await this.compareAndMergePlatesArg();
    await this.inicia();
  }

  async getUserLogado() {
    this.usuarioLogado = await this.servicoAutenticacao.obterUsuarioLogado()
  }

  async atualizarMarcadores(): Promise<void> {
    this.markerCoordinates = [];
    this.carrosVerdes = 0;
    this.carrosVermelhos = 0;
    this.carrosComSinal = 0;
    this.carrosSemSinal = 0;
    // console.log(this.posicaoArg)
    // console.log("atualizou marcadores")
    this.markerCoordinates = await this.posicao
      .filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != "")
      .map((item: any) => ({
        // Outros campos do objeto que você deseja manter
        Longitude: item.Longitude.toString(),
        Latitude: item.Latitude.toString()
      }))
      .map((item: any) => [item?.Longitude, item?.Latitude] as [number, number])
      .concat(
        this.posicaoSul
          .filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != "")
          .map((item: any) => [item?.Longitude, item?.Latitude] as [number, number])
      )
      .concat(
        this.posicaoArg
          .filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != "")
          .map((item: any) => [item?.Longitude, item?.Latitude] as [number, number])
      )
      .concat(
        this.containers
          .filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != "")
          .map((item: any) => [item?.Longitude, item?.Latitude] as [number, number])
      )
    // console.log(this.markerCoordinates)

  }

  async atualizarCarros(): Promise<void> {
    this.carros = [];
    this.carrosVerdes = 0;
    this.carrosVermelhos = 0;
    // console.log("atualizou carros")
    // console.log(this.posicao[0])
    // console.log(this.posicaoLOTS[0])
    // console.log(this.posicaoSul)
    // console.log(this.posicaoArg)
    this.carros = this.posicao
      .filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != "")
      .concat(
        this.posicaoSul
          .filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != "")
      ).concat(
        this.posicaoArg
          .filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != "")
      ).concat(
        this.containers
          .filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != "")
      )
    // console.log(this.carros.length)
  }

  async handleChange() {
    // Esta função será chamada sempre que o estado do checkbox mudar
    // console.log('O status do checkbox mudou.');
    await this.inicia();
  }

  removeAllMarkers(): void {
    // console.log("entrou remove")
    // console.log(this.marcadores)
    this.marcadores.forEach(marker => marker.remove());
    this.marcadores = [];
  }

  async inicia(): Promise<void> {
    // console.log(this.posicao)
    // console.log(this.posicao.filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != ""))
    await this.atualizarMarcadores();
    await this.atualizarCarros();

    const adicionarMarcadoresImportantes = (locais: any[]) => {
      this.removeAllMarkers();
      locais.forEach(local => {
        // console.log(local)
        const { latitude, longitude, popupContent } = local;
        // Converta as coordenadas para números
        const lat = parseFloat(latitude);
        const lng = parseFloat(longitude);
        try {
          // Verifique se as coordenadas estão dentro dos intervalos válidos
          if (isNaN(lat) || isNaN(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180) {
            console.log(local)
            console.log(lat)
            console.log(lng)
            console.warn(`Coordenadas inválidas para o local: ${local}`);
            return; // Pule este local se as coordenadas forem inválidas
          }
          // Crie o marcador
          const marker = new maplibregl.Marker()
            .setLngLat([longitude, latitude]) // Use as coordenadas corretamente como uma tupla [longitude, latitude]
            .addTo(this.map);
          // Adicione um popup associado ao marcador (opcional)
          if (popupContent) {
            const popup = new maplibregl.Popup({ closeOnClick: false }).setText(popupContent);
            marker.setPopup(popup);
            // Abra o popup imediatamente
            // if(this.verNomeLocais){
            // popup.setLngLat([lng, lat]).addTo(this.map);
            // }
          }
          // Adicione o marcador ao array de marcadores
          this.marcadores.push(marker);
        } catch {
          console.log(local)
          console.log('lat: ', lat)
          console.log('lng: ', lng)
        }
      });
    };

    // Array com informações dos locais importantes
    // const locaisImportantes = [
    //   {
    //     latitude: -23.712620487057045,
    //     longitude: -46.56663637422363,
    //     popupContent: 'Scania Latin América',
    //   },
    //   {
    //     latitude: -23.74041897283576,
    //     longitude: -46.564176262118174,
    //     popupContent: 'LCB Scania',
    //   },
    // ];

    if (this.verLocais) {
      await adicionarMarcadoresImportantes(this.fornecedores);
    } else {
      await this.removeAllMarkers();
    }

    const atualizarMarcadores = async () => {
      // Remover marcadores existentes
      await this.markers.forEach(async marker => {
        await marker.remove();
      });
      // Limpar a lista de marcadores
      this.markers.length = 0;
      this.index = 0;
      // Restante do código para adicionar novos marcadores e popups
      await this.markerCoordinates.forEach(async (coordinates, index) => {
        let placa = '';
        // //console.log(this.markerCoordinates.length)
        // console.log(coordinates)
        // console.log(index)
        // console.log(this.markerCoordinates)
        placa = this.getPosicaoPlaca(coordinates); // Obtenha a placa com base nas coordenadas

        if (this.placaFiltrada !== '' && this.placaFiltrada !== null && this.placaFiltrada !== undefined) {
          const placaLowerCase = placa.toLowerCase();
          const filtroLowerCase = this.placaFiltrada.toLowerCase();
          // Verifica se as letras estão na sequência
          if (!placaLowerCase.includes(filtroLowerCase)) {
            return; // Pula para a próxima iteração do loop
          }
        }

        if (this.carros[index]['DataBordo'] === undefined) {
          this.carros[index]['Conexao'] = false;
        } else {
          this.DataAtual = new Date();
          var outraData = new Date(this.carros[index]['DataBordo']);
          if (new Date(outraData.setHours(outraData.getHours() + 1)) > this.DataAtual) {
            this.carros[index]['Conexao'] = true;
          } else {
            this.carros[index]['Conexao'] = false;
          }
        }

        if (this.carros[index].description && this.carros[index].description.includes('TCM') && !this.verTCM) return; // Pula para a próxima iteração do loop
        if (this.carros[index].description && this.carros[index].description.includes('JSL') && !this.verJSL) return; // Pula para a próxima iteração do loop
        if (this.carros[index].description && this.carros[index].description.includes('ARG') && !this.verJSLARG) return; // Pula para a próxima iteração do loop
        if (this.carros[index].Transportadora && this.carros[index].Transportadora == 'LOTS' && !this.verLOTS) return; // Pula para a próxima iteração do loop
        if (this.carros[index].transportador && this.carros[index].transportador.includes('SUZAN') && !this.verSUZAN) return; // Pula para a próxima iteração do loop
        if (this.carros[index].transportador && this.carros[index].transportador.includes('LOTS') && !this.verLOTS) return; // Pula para a próxima iteração do loop
        if (this.carros[index].Conexao && this.carros[index].Conexao == true && !this.verComSinal) return; // Pula para a próxima iteração do loop
        if (this.carros[index].Conexao != true && !this.verSemSinal) return; // Pula para a próxima iteração do loop
        if (this.carros[index].Transportadora && this.carros[index].Transportadora == "SESE" && !this.verSESE) return; // Pula para a próxima iteração do loop
        if (this.placaFiltrada && this.carros[index].Plate && !this.carros[index].Plate.toUpperCase().includes(this.placaFiltrada.toUpperCase())) return; // Pula para a próxima iteração do loop

        const horaAtual = new Date().getTime();

        try {
          this.maiorHorarioJanela = 0;
          let maiorHorarioItem = 0;
          let horarioJanela = this.carros[index]['Janela'] && this.carros[index]['PassoEntrega'] != 1 && this.carros[index]['PassoEntrega'] != 2 ? this.carros[index]['Janela'] : "9900-01-01T00:00:00.000Z";
          horarioJanela = horarioJanela.replace("Z", "");
          const dataHorarioJanela = new Date(horarioJanela)
          const dataFormatadaHorarioJanela = dataHorarioJanela.getTime();

          let horarioJanela1 = this.carros[index]['Janela 1'] && this.carros[index]['Passo Fornecedor1'] != 1 && this.carros[index]['Passo Fornecedor1'] != 2 ? this.carros[index]['Janela 1'] : "9900-01-01T00:00:00.000Z";
          horarioJanela1 = horarioJanela1.replace("Z", "");
          const dataHorarioJanela1 = new Date(horarioJanela1);
          const dataFormatadaHorarioJanela1 = dataHorarioJanela1.getTime(); // Você pode ajustar o formato conforme necessário

          let horarioJanela2 = this.carros[index]['Janela 2'] && this.carros[index]['Passo Fornecedor2'] != 1 && this.carros[index]['Passo Fornecedor2'] != 2 ? this.carros[index]['Janela 2'] : "9900-01-01T00:00:00.000Z";
          horarioJanela2 = horarioJanela2.replace("Z", "");
          const dataHorarioJanela2 = new Date(horarioJanela2);
          const dataFormatadaHorarioJanela2 = dataHorarioJanela2.getTime(); // Você pode ajustar o formato conforme necessário

          let horarioJanela3 = this.carros[index]['Janela 3'] && this.carros[index]['Passo Fornecedor3'] != 1 && this.carros[index]['Passo Fornecedor3'] != 2 ? this.carros[index]['Janela 3'] : "9900-01-01T00:00:00.000Z";
          horarioJanela3 = horarioJanela3.replace("Z", "");
          const dataHorarioJanela3 = new Date(horarioJanela3);
          const dataFormatadaHorarioJanela3 = dataHorarioJanela3.getTime(); // Você pode ajustar o formato conforme necessário

          let horarioJanela4 = this.carros[index]['Janela 4'] && this.carros[index]['Passo Fornecedor4'] != 1 && this.carros[index]['Passo Fornecedor4'] != 2 ? this.carros[index]['Janela 4'] : "9900-01-01T00:00:00.000Z";
          horarioJanela4 = horarioJanela4.replace("Z", "");
          const dataHorarioJanela4 = new Date(horarioJanela4);
          const dataFormatadaHorarioJanela4 = dataHorarioJanela4.getTime(); // Você pode ajustar o formato conforme necessário

          let horarioJanelaDestino1 = this.carros[index]['JanelaDestino 1'] && this.carros[index]['Passo Destino1'] != 1 && this.carros[index]['Passo Destino1'] != 2 ? this.carros[index]['JanelaDestino 1'] : "9900-01-01T00:00:00.000Z";
          horarioJanelaDestino1 = horarioJanelaDestino1.replace("Z", "");
          const datahorarioJanelaDestino1 = new Date(horarioJanelaDestino1);
          const dataFormatadahorarioJanelaDestino1 = datahorarioJanelaDestino1.getTime(); // Você pode ajustar o formato conforme necessário

          let horarioJanelaDestino2 = this.carros[index]['JanelaDestino 2'] && this.carros[index]['Passo Destino2'] != 1 && this.carros[index]['Passo Destino2'] != 2 ? this.carros[index]['JanelaDestino 2'] : "9900-01-01T00:00:00.000Z";
          horarioJanelaDestino2 = horarioJanelaDestino2.replace("Z", "");
          const datahorarioJanelaDestino2 = new Date(horarioJanelaDestino2);
          const dataFormatadahorarioJanelaDestino2 = datahorarioJanelaDestino2.getTime(); // Você pode ajustar o formato conforme necessário

          let horarioJanelaDestino3 = this.carros[index]['JanelaDestino 3'] && this.carros[index]['Passo Destino3'] != 1 && this.carros[index]['Passo Destino3'] != 2 ? this.carros[index]['JanelaDestino 3'] : "9900-01-01T00:00:00.000Z";
          horarioJanelaDestino3 = horarioJanelaDestino3.replace("Z", "");
          const datahorarioJanelaDestino3 = new Date(horarioJanelaDestino3);
          const dataFormatadahorarioJanelaDestino3 = datahorarioJanelaDestino3.getTime(); // Você pode ajustar o formato conforme necessário

          let horarioJanelaDestino4 = this.carros[index]['JanelaDestino 4'] && this.carros[index]['Passo Destino4'] != 1 && this.carros[index]['Passo Destino4'] != 2 ? this.carros[index]['JanelaDestino 4'] : "9900-01-01T00:00:00.000Z";
          horarioJanelaDestino4 = horarioJanelaDestino4.replace("Z", "");
          const datahorarioJanelaDestino4 = new Date(horarioJanelaDestino4);
          const dataFormatadahorarioJanelaDestino4 = datahorarioJanelaDestino4.getTime(); // Você pode ajustar o formato conforme necessário

          maiorHorarioItem = Math.min(dataFormatadaHorarioJanela, dataFormatadaHorarioJanela1, dataFormatadaHorarioJanela2, dataFormatadaHorarioJanela3, dataFormatadaHorarioJanela4,
            dataFormatadahorarioJanelaDestino1, dataFormatadahorarioJanelaDestino2, dataFormatadahorarioJanelaDestino3, dataFormatadahorarioJanelaDestino4);

          await this.someMethod(index);
          await this.findLocationNextPoint(this.carros[index], this.locais);
          // console.log(this.carros[index].nextPoint)
          // console.log(this.carros[index].nextPointCompleto)
          debugger


          if (maiorHorarioItem > horaAtual) {
            // //console.log("verde")
            if (!this.carros[index].nextPointCompleto.descarga) {
              this.markerImagePath = 'assets/truckVerdeIndo.png';
            } else {
              this.markerImagePath = 'assets/truckVerdeNewVoltando.png';
            }
            this.carros[index].cor = 'verde';
            // console.log(this.carros[index])
            this.carrosVerdes += 1;
          } else {
            // //console.log("vermelho")
            if (!this.carros[index].nextPointCompleto.descarga) {
              this.markerImagePath = 'assets/truckVermelhoNewIndo.png';
            } else {
              this.markerImagePath = 'assets/truckVermelhoNewVoltando.png';
            }
            this.carros[index].cor = 'vermelho';
            this.carrosVermelhos += 1;
          }

          if (this.carros[index].Conexao) {
            // console.log(this.carros[index].Conexao)
            this.markerImageSinal = 'assets/sinal.png';
            this.carrosComSinal += 1;
            // console.log(this.carrosComSinal)
          } else {
            this.markerImageSinal = 'assets/semSinal.png';
            this.carrosSemSinal += 1;
            // console.log(this.carros[index])
          }
          // console.log(this.markerImagePath)
        } catch {
          // console.log(index)
        }

        // console.log(this.verVerdes)
        // console.log(this.verVermelhos)
        try {
          if (this.carros[index].cor == 'verde' && !this.verVerdes) return; // Pula para a próxima iteração do loop
          if (this.carros[index].cor == 'vermelho' && !this.verVermelhos) return; // Pula para a próxima iteração do loop
        } catch {
          // console.log(this.carros[index])
        }


        let marker = new maplibregl.Marker({ element: this.createMarkerElement(this.markerImagePath, this.markerImageSinal) })
          .setLngLat(coordinates)
          .addTo(this.map)

        let endereco = '';
        let fornecedor = '';
        endereco = this.getPosicaoEndereco(coordinates); // Obtenha o endereço com base nas coordenadas
        fornecedor = this.getPosicaoFornecedores(coordinates); // Obtenha o fornecedor com base nas coordenadas

        // this.carros[index].nextPoint = this.encontrarNextPoint(this.carros[index]);

        const popup = new maplibregl.Popup({ closeButton: true, closeOnClick: true })
          .setLngLat(coordinates)
          .setHTML(`<span style="font-weight: bold; font-size: 1.1em">Placa: ${placa}</span>
            <br>Fornecedores: ${fornecedor ? fornecedor : this.carros[index].idContainer ? this.carros[index].idContainer : this.carros[index].viagem ? "viagem " + this.carros[index].viagem :
              'Fornecedor não disponível'}
            <br>Peso: ${this.carros[index]?.['Weight Loaded'] ? this.carros[index]?.['Weight Loaded'] : 'Peso não disponível'}
            <br>Cubagem: ${this.carros[index]?.['Cubage'] ? this.carros[index]?.['Cubage'] : 'Cubagem não disponível'}
            <br>Volumes: ${this.carros[index]?.['Volumes'] ? this.carros[index]?.['Volumes'] : 'Volumes não disponível'}
            <br>Distancia: ${this.carros[index]?.['Total Distance'] ? this.carros[index]?.['Total Distance'] : 'Distancia não disponível'}
            <br>Endereço Atual: ${endereco ? endereco : this.carros[index]?.Endereco}`);

        marker.getElement().addEventListener('mouseover', () => {
          popup.addTo(this.map);
        });

        marker.getElement().addEventListener('click', () => {
          // console.log(this.carros[index])
          this.localizaCarroEdit(placa)
        });

        marker.getElement().addEventListener('mouseout', () => {
          popup.remove();
        });

        this.markers.push(marker);
        this.index++;
      });

      const pointFeatures: PointFeature<any>[] = this.markers.map(marker => {
        const [longitude, latitude] = marker.getLngLat().toArray();
        return {
          type: 'Feature',
          properties: {},
          geometry: {
            type: 'Point',
            coordinates: [longitude, latitude],
          },
        };
      });

      this.cluster.load(pointFeatures);
    };

    const ocultarMarcadores = () => {
      this.markers.forEach(marker => {
        const placa = this.getPosicaoPlaca(marker.getLngLat().toArray()); // Obtenha a placa do marcador

        if (this.placaFiltrada !== '' && this.placaFiltrada !== null && this.placaFiltrada !== undefined) {
          if (placa !== this.placaFiltrada) {
            marker.getElement().style.display = 'none'; // Oculta o marcador
          } else {
            marker.getElement().style.display = ''; // Exibe o marcador
          }
        }
      });
    };

    await atualizarMarcadores();

    // Chamar a função ocultarMarcadores() sempre que o filtro for alterado
    const inputFiltro = document.getElementById('input-filtro');
    if (inputFiltro) {
      inputFiltro.addEventListener('input', ocultarMarcadores);
    }
  }

  async someMethod(index: number) {
    const nextPoint = await this.encontrarNextPoint(this.carros[index]);
    this.carros[index].nextPoint = nextPoint;
    // console.log(this.carros[index].nextPoint);
  }

  async atualizarPlacaFiltrada(event: Event) {
    const target = event.target as HTMLInputElement;
    const novoValor = target.value;
    if (this.placaFiltrada !== '' && this.placaFiltrada !== null && this.placaFiltrada !== undefined) {
      const placaLowerCase = novoValor.toLowerCase();
      const filtroLowerCase = this.placaFiltrada.toLowerCase();
      if (placaLowerCase.indexOf(filtroLowerCase) == -1) {
        return;
      }
    }
    this.placaFiltrada = novoValor;
    await this.inicia();
  }

  private getPosicaoEndereco(coordinates: [number, number]): string {
    const posicao = this.posicao.find(item => item.Longitude == coordinates[0] && item.Latitude == coordinates[1]);
    const posicaoSul = this.posicaoSul.find(item => item.Longitude == coordinates[0] && item.Latitude == coordinates[1]);
    const posicaoArg = this.posicaoArg.find(item => item.Longitude == coordinates[0] && item.Latitude == coordinates[1]);

    let plate = "";

    if (posicao && posicao.Endereco) {
      plate += posicao.Endereco;
    }

    if (posicaoSul && posicaoSul.Endereco) {
      plate += posicaoSul.Endereco;
    }

    if (posicaoArg && posicaoArg.Endereco) {
      plate += posicaoArg.Endereco;
    }

    return plate;
  }


  private getPosicaoPlaca(coordinates: [number, number]): string {
    let posicao = null;
    let posicaoContainer = null;
    let posicaoSul = null;
    let posicaoArg = null;
    posicao = this.posicao.find(item => item.Longitude == coordinates[0] && item.Latitude == coordinates[1]);
    posicaoContainer = this.containers.find(item => item.Longitude == coordinates[0] && item.Latitude == coordinates[1]);
    posicaoSul = this.posicaoSul.find(item => item.Longitude == coordinates[0] && item.Latitude == coordinates[1]);
    posicaoArg = this.posicaoArg.find(item => item.Longitude == coordinates[0] && item.Latitude == coordinates[1]);
    // console.log(this.containers)
    // console.log(posicaoContainer)

    let plate = "";

    if (posicao && posicao.Plate) {
      plate += posicao.Plate;
      // console.log(plate)
    }

    if (posicaoContainer && posicaoContainer.Plate) {
      plate += posicaoContainer.Plate;
      // console.log(plate)
    }

    if (posicaoSul && posicaoSul.Plate) {
      plate += posicaoSul.Plate;
      // console.log(plate)
    }

    if (posicaoArg && posicaoArg.Plate) {
      plate += posicaoArg.Plate;
      // console.log(plate)
    }

    return plate;
  }

  private getPosicaoFornecedores(coordinates: [number, number]): string {
    const posicao = this.posicao.find(item => item.Longitude === coordinates[0] && item.Latitude === coordinates[1]);
    const posicaoContainer = this.containers.find(item => item.Longitude === coordinates[0] && item.Latitude === coordinates[1]);
    const posicaoSul = this.posicaoSul.find(item => item.Longitude === coordinates[0] && item.Latitude === coordinates[1]);
    const posicaoArg = this.posicaoArg.find(item => item.Longitude === coordinates[0] && item.Latitude === coordinates[1]);

    let fornecedor = "";

    if (posicaoContainer && posicaoContainer['terminalOrigem']) {
      fornecedor += (" - " + posicaoContainer['terminalOrigem']);
    }

    if (posicao && posicao['Fornecedor 1']) {
      fornecedor += (" - " + posicao['Fornecedor 1']);
    }

    if (posicao && posicao['Fornecedor 2']) {
      fornecedor += (" - " + posicao['Fornecedor 2']);
    }
    if (posicao && posicao['Fornecedor 3']) {
      fornecedor += (" - " + posicao['Fornecedor 3']);
    }
    if (posicao && posicao['Fornecedor 4']) {
      fornecedor += (" - " + posicao['Fornecedor 4']);
    }

    if (posicaoSul && posicaoSul['Fornecedor 1']) {
      fornecedor += (" - " + posicaoSul['Fornecedor 1']);
    }
    if (posicaoSul && posicaoSul['Fornecedor 2']) {
      fornecedor += (" - " + posicaoSul['Fornecedor 2']);
    }
    if (posicaoSul && posicaoSul['Fornecedor 3']) {
      fornecedor += (" - " + posicaoSul['Fornecedor 3']);
    }
    if (posicaoSul && posicaoSul['Fornecedor 4']) {
      fornecedor += (" - " + posicaoSul['Fornecedor 4']);
    }

    if (posicaoArg && posicaoArg['Fornecedor 1']) {
      fornecedor += (" - " + posicaoArg['Fornecedor 1']);
    }
    if (posicaoArg && posicaoArg['Fornecedor 2']) {
      fornecedor += (" - " + posicaoArg['Fornecedor 2']);
    }
    if (posicaoArg && posicaoArg['Fornecedor 3']) {
      fornecedor += (" - " + posicaoArg['Fornecedor 3']);
    }
    if (posicaoArg && posicaoArg['Fornecedor 4']) {
      fornecedor += (" - " + posicaoArg['Fornecedor 4']);
    }
    return fornecedor;
  }

  teste() {
    console.log("teste imprimir");
  }

  async getPosicaoFromDynamoDB(): Promise<void> {
    this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.queryInterplantas, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });

      if (response.statusCode == 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            const plateMap = new Map();
            items.forEach(item => {
              const plate = item.Plate;
              // console.log(plate)         
              if (!plateMap.has(plate)) {
                // Se a placa não existir no Map, adicione o item com todas as suas propriedades
                plateMap.set(plate, { ...item, checked: false });
              } else {
                // Se a placa já existir, mescle as propriedades (se necessário)
                const existingItem = plateMap.get(plate);
                // Exemplo: Combine as propriedades manualmente, ou você pode ajustar conforme a lógica de mescla que precisa
                plateMap.set(plate, {
                  ...existingItem,
                  ...item, // Isso substituirá as propriedades do item existente com as novas
                  checked: false // Mantenha o "checked" como false
                });
              }
            });

            // Converta o Map para um array e filtre os itens de "ViagemCompleta"
            this.posicao = Array.from(plateMap.values())
              .filter(item => item.ViagemCompleta != true && item.ViagemCompleta != "true" && item.ViagemCompleta != "True");

            // console.log(this.posicao);
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Response is undefined or null');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async getContainersEXP(): Promise<void> {
    this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos("Container_exportacao", this.urlConsultaCompactada, 'All',
          "Janela", this.referenceDate, 4)).subscribe(
            (res: any) => resolve(res),
            (error: any) => reject(error)
          );
      });

      if (response.statusCode == 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.containersEXP = items
            this.containersEXP = this.containersEXP
              .filter(item => item.Finalizada != true && item.Finalizada != "true" && item.Finalizada != "True" && item.FinalizadaManual != true);

            // console.log(this.containersEXP)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Response is undefined or null');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  // async getPosicaoFromDynamoDB(): Promise<void> {
  //   this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
  //   try {
  //     const response: any = await new Promise(async (resolve, reject) => {
  //       (await this.dynamodbService.getItemsVolumesAltos(this.queryInterplantas, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, this.numDays)).subscribe(
  //         (res: any) => resolve(res),
  //         (error: any) => reject(error)
  //       );
  //     });
  //     if (response.statusCode == 200) {
  //       try {
  //         // //console.log(response.body)
  //         const items = JSON.parse(response.body);
  //         ////console.log(items)
  //         if (Array.isArray(items)) {
  //           console.log(items)
  //           // this.posicao = items
  //           //   .map(item => ({ ...item, checked: false }))
  //           //   .filter(item => item.ViagemCompleta != true && item.ViagemCompleta != "true" && item.ViagemCompleta != "True");
  //           const uniquePlates = new Set(); // Conjunto para armazenar placas únicas
  //           this.posicao = items.reduce((filteredItems, item) => {
  //             if (!uniquePlates.has(item.Plate)) { // Verifique se a placa já existe
  //               uniquePlates.add(item.Plate); // Adicione a placa ao conjunto
  //               filteredItems.push({ ...item, checked: false }); // Adicione o item ao array de posições
  //             }
  //             return filteredItems;
  //           }, []);
  //           this.posicao = this.posicao
  //             .filter(item => item.ViagemCompleta != true && item.ViagemCompleta != "true" && item.ViagemCompleta != "True");

  //             console.log(this.posicao )
  //         } else {
  //           console.error('Invalid items data:', items);
  //         }
  //       } catch (error) {
  //         console.error('Error parsing JSON:', error);
  //       }
  //     } else {
  //       console.error('Response is undefined or null');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // }

  async getContainers(): Promise<void> {
    this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    try {
      const lambdaEvent = {
        "tableName": "items_Excel_Container",
        "searchConditions":
          { "column": "Finalizada", "word": true, "negate": "true" },
        //   { "column": "Finalizada", "word": "True", "negate": true }

      };
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaComFiltroNovo, 'filtro')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      // console.log(response)
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.containers = items
            // console.log(items)
            // const uniquePlates = new Set(); // Conjunto para armazenar placas únicas
            // this.containers = items.reduce((filteredItems, item) => {
            //   if (!uniquePlates.has(item.plate)) { // Verifique se a placa já existe
            //     uniquePlates.add(item.plate); // Adicione a placa ao conjunto
            //     filteredItems.push({ ...item, checked: false }); // Adicione o item ao array de posições
            //   }
            //   return filteredItems;
            // }, []);
            this.containers = this.containers
              .filter(item => item.Finalizada != true && item.Finalizada != "true" && item.Finalizada != "True" && item.FinalizadaManual != true);

            // console.log(this.containers)

          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
        // console.log(this.containers)
      } else {
        console.error('Response is undefined or null');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  // async getContainersEXP(): Promise<void> {
  //   this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
  //   try {
  //     const lambdaEvent = {
  //       "tableName": "Container_exportacao",
  //       "searchConditions":
  //         { "column": "Finalizada", "word": true, "negate": "true" },
  //       //   { "column": "Finalizada", "word": "True", "negate": true }

  //     };
  //     const response: any = await new Promise(async (resolve, reject) => {
  //       (await this.dynamodbService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaComFiltroNovo, 'filtro')).subscribe(
  //         (res: any) => resolve(res),
  //         (error: any) => reject(error)
  //       );
  //     });
  //     // console.log(response)
  //     if (response.statusCode === 200) {
  //       try {
  //         const items = JSON.parse(response.body);
  //         if (Array.isArray(items)) {
  //           this.containersEXP = items
  //           // console.log(items)
  //           // const uniquePlates = new Set(); // Conjunto para armazenar placas únicas
  //           // this.containersEXP = items.reduce((filteredItems, item) => {
  //           //   if (!uniquePlates.has(item.plate)) { // Verifique se a placa já existe
  //           //     uniquePlates.add(item.plate); // Adicione a placa ao conjunto
  //           //     filteredItems.push({ ...item, checked: false }); // Adicione o item ao array de posições
  //           //   }
  //           //   return filteredItems;
  //           // }, []);
  //           this.containersEXP = this.containersEXP
  //             .filter(item => item.Finalizada != true && item.Finalizada != "true" && item.Finalizada != "True" && item.FinalizadaManual != true);

  //           console.log(this.containersEXP)

  //         } else {
  //           console.error('Invalid items data:', items);
  //         }
  //       } catch (error) {
  //         console.error('Error parsing JSON:', error);
  //       }
  //       // console.log(this.containersEXP)
  //     } else {
  //       console.error('Response is undefined or null');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // }

  async getPosicaoLOTSFromDynamoDB(): Promise<void> {
    try {
      const lambdaEvent = {
        "tableName": "positionLOTS",
        "searchConditions": [
          //   { "column": "Finalizada", "word": true, "negate": true },
          //   { "column": "Finalizada", "word": "true", "negate": true },
          //   { "column": "Finalizada", "word": "True", "negate": true }
        ]
      };
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaTrips, 'filtro')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          // return new Promise<void>(async (resolve, reject) => {
          //   const filtro = 'All';
          //   try {
          //     const response = await (await this.dynamodbService.getItems(this.query2, this.urlConsulta, filtro)).toPromise();
          //     if (response) {
          //       const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.posicaoLOTS = items
            // this.posicaoLOTS.forEach(item => {
            //   console.log(item.placa )
            // })
            // .map(item => ({ ...item, checked: false }))
          } else {
            console.error('Invalid items data:', items);
            // reject('Invalid items data');
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Response is undefined or null');
        //   reject('Invalid response');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      // reject('Error fetching data');
    }
    // });
  }


  async getPosicaoMilkSulFromDynamoDB(): Promise<void> {
    try {
      const lambdaEvent = {
        // "tableName": "Itens_Jetta",
        // "searchConditions": [
        //   { "column": "Finalizada", "word": true, "negate": true },
        //   { "column": "Finalizada", "word": "true", "negate": true },
        //   { "column": "Finalizada", "word": "True", "negate": true }
        // ]
      };
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaTrips, 'filtro')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          // //console.log(items)
          if (Array.isArray(items)) {
            // console.log(items)
            // items.forEach(item => {
            //   if(item.Plate == "EFO9D76"){
            //     console.log(item)
            //   }
            // })
            // this.posicaoSul = items
            //   .map(item => ({ ...item, checked: false }))
            //   .filter(item => item.Finalizada != true && item.Finalizada != "true" && item.Finalizada != "True");

            const uniquePlates = new Set(); // Conjunto para armazenar placas únicas
            this.posicaoSul = items.reduce((filteredItems, item) => {
              if (!uniquePlates.has(item.Plate)) { // Verifique se a placa já existe
                uniquePlates.add(item.Plate); // Adicione a placa ao conjunto
                filteredItems.push({ ...item, checked: false }); // Adicione o item ao array de posições
              }
              return filteredItems;
            }, []);

            this.posicaoSul = this.posicaoSul
              .filter(item => item.Finalizada != true && item.Finalizada != "true" && item.Finalizada != "True" && item.FinalizadaManual != true);

          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getPosicaoMilkArgFromDynamoDB(): Promise<void> {
    try {
      const lambdaEvent = {
        "tableName": "items_Excel_Karrara",
        "searchConditions": [
          //   { "column": "Finalizada", "word": true, "negate": true },
          //   { "column": "Finalizada", "word": "true", "negate": true },
          //   { "column": "Finalizada", "word": "True", "negate": true }
        ]
      };
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaTrips, 'filtro')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            const uniquePlates = new Set(); // Conjunto para armazenar placas únicas
            this.posicaoArg = items.reduce((filteredItems, item) => {
              if (!uniquePlates.has(item.Plate)) { // Verifique se a placa já existe
                uniquePlates.add(item.Plate); // Adicione a placa ao conjunto
                filteredItems.push({ ...item, checked: false }); // Adicione o item ao array de posições
              }
              return filteredItems;
            }, []);

            this.posicaoArg = this.posicaoArg
              .filter(item => item.Finalizada != true && item.Finalizada != "true" && item.Finalizada != "True" && item.FinalizadaManual != true);
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getPosicaoMilkRastreioFromDynamoDB(): Promise<void> {
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItems(this.query4, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.posicaoSulRastreio = items
              .map(item => ({ ...item, checked: false }))
              .filter(item => item.Finalizada != true && item.Finalizada != "true" && item.Finalizada != "True" && item.FinalizadaManual != true);
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
            // Filtra os itens com chave 'DataBordo' indefinida e item.Finalizada !== true          
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getLocais(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.queryFornecedores, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.locais = items;
              // console.log(this.locais)
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async getFornecedoresFromDynamoDB(): Promise<void> {
    try {
      const lambdaEvent = {
        "tableName": "Fornecedores_Karrara_Transport",
        "searchConditions": [
          //   { "column": "Finalizada", "word": true, "negate": true },
          //   { "column": "Finalizada", "word": "true", "negate": true },
          //   { "column": "Finalizada", "word": "True", "negate": true }
        ]
      };
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaTrips, 'filtro')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            // this.fornecedores = items
            this.fornecedores = items.map(item => ({
              latitude: parseFloat(item.latitude),
              longitude: parseFloat(item.longitude),
              popupContent: item.local
            }));
            // console.log(this.fornecedores)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  compareAndMergePlates(): void {
    // console.log(this.posicaoSul);
    if (this.posicaoSul && this.posicaoSulRastreio) {
      for (let i = 0; i < this.posicaoSul.length; i++) {
        const plate = this.posicaoSul[i].Plate;
        const matchingPlate = this.posicaoSulRastreio.find(item => item.ID === plate);
        if (matchingPlate) {
          // console.log(matchingPlate)
          this.posicaoSul[i].IdTrip = this.posicaoSul[i].ID;
          // Copiar as demais chaves de matchingPlate para this.posicaoSul[i]
          Object.keys(matchingPlate).forEach(key => {
            if (key !== 'Plate') {
              this.posicaoSul[i][key] = matchingPlate[key];
            }
          });
        }
      }
    }
    // console.log(this.posicaoSul);
  }

  compareAndMergePlatesArg(): void {
    if (this.posicaoArg && this.posicaoSulRastreio) {
      for (let i = 0; i < this.posicaoArg.length; i++) {
        const plate = this.posicaoArg[i].Plate;
        const matchingPlate = this.posicaoSulRastreio.find(item => item.ID === plate);
        // console.log(this.posicaoArg[i])
        // console.log(matchingPlate)
        if (matchingPlate) {
          this.posicaoArg[i].IdTrip = this.posicaoArg[i].ID;

          // Copiar as demais chaves de matchingPlate para this.posicaoSul[i]
          Object.keys(matchingPlate).forEach(key => {
            if (key !== 'Plate') {
              // console.log(key)
              this.posicaoArg[i][key] = matchingPlate[key];
              // console.log(this.posicaoArg[i][key])
            }
          });
        }
      }
    }
    // //console.log(this.posicaoArg);
  }

  convertTimestampToFormattedDate(timestamp: number): string {
    // Converta para segundos dividindo por 1000
    const timestampSeconds = timestamp / 1000;
    // Crie um objeto Date
    const date = new Date(timestampSeconds * 1000); // Multiplique por 1000 para obter milissegundos
    // Formate a data no formato desejado
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Use formato de 24 horas
    }).replace(',', ''); // Remova a vírgula
    return formattedDate;
  }

  compareAndMergePlatesLOTS(): void {
    if (this.posicao && this.posicaoLOTS) {
      for (let i = 0; i < this.posicao.length; i++) {
        const plate = this.posicao[i].Plate;
        // console.log(this.posicao[i])
        const matchingPlate = this.posicaoLOTS.find(item => item.placa === plate);
        // console.log(matchingPlate)
        if (matchingPlate) {
          this.posicao[i].IdTrip = this.posicao[i].ID;
          // Copiar as demais chaves de matchingPlate para this.posicaoSul[i]
          Object.keys(matchingPlate).forEach(key => {
            if (key !== 'Plate') {
              // console.log(key)
              this.posicao[i][key] = matchingPlate[key];
              // console.log(this.posicao[i][key])
            }
          });
        }
      }
    }
    // console.log(this.posicao);
  }

  async compareAndMergePlatesLOTSContainers(): Promise<void> {
    // console.log(this.containers)
    // console.log(this.posicaoLOTS)
    if (this.containers && this.posicaoLOTS) {
      // this.posicaoLOTS.forEach(item => {
      //   console.log(item.placa)
      // })
      for (let i = 0; i < this.containers.length; i++) {
        const plate = this.containers[i].Plate;
        // console.log(this.containers[i].Plate)     
        const matchingPlate = await this.posicaoLOTS.find(item => item.placa == plate);
        // console.log(matchingPlate)
        if (matchingPlate) {
          this.containers[i].IdTrip = this.containers[i].ID;
          // Copiar as demais chaves de matchingPlate para this.posicaoSul[i]
          Object.keys(matchingPlate).forEach(key => {
            if (key !== 'Plate') {
              // console.log(key)
              this.containers[i][key] = matchingPlate[key];
              // console.log(this.containers[i][key])
            }
          });
        }
      }
    }
    // console.log(this.containers);
  }

  private createMarkerElement(imageUrl: string, imageUrl2: string): HTMLDivElement {
    const element = document.createElement('div');
    element.className = 'small-marker';
    // Aplicar estilo para empilhar as imagens verticalmente
    element.style.display = 'flex';
    element.style.flexDirection = 'column';
    element.style.alignItems = 'center'; // Centralizar as imagens
    const image = document.createElement('img');
    const image2 = document.createElement('img');
    image.src = imageUrl;
    image2.src = imageUrl2;
    element.appendChild(image2);
    element.appendChild(image);
    return element;
  }

  async localizaCarroEdit(placa: string): Promise<void> {
    // console.log("edit");
    // console.log(placa);
    // Verificar em this.posicao
    this.item = await this.posicao.find(item => item.Plate === placa);
    if (this.item) {
      this.edit2 = true;
      // console.log(this.item)
      await this.calculaDistanciaAteNextPoint(this.item)
      this.editDialog(this.item)
      return;
    }
    // Verificar em this.containers
    this.item = await this.containers.find(item => item.Plate === placa);
    if (this.item) {
      this.edit2 = true;
      this.item.nextPoint = this.item.destino;
      // console.log(this.item)
      await this.calculaDistanciaAteNextPoint(this.item)
      this.editDialog(this.item)
      return;
    }
    // Verificar em this.posicaoArg
    this.item = await this.posicaoArg.find(item => item.Plate === placa);
    if (this.item) {
      this.edit2 = true;
      // console.log(this.item)
      await this.calculaDistanciaAteNextPoint(this.item)
      this.editDialog(this.item)
      return;
    }
    // Verificar em this.posicaoSul
    this.item = await this.posicaoSul.find(item => {
      if (item.Plate === placa) {
        return item;
      }
    });
    if (this.item) {
      this.edit2 = true;
      // console.log(this.item)
      await this.calculaDistanciaAteNextPoint(this.item)
      this.editDialog(this.item)
      return;
    }
    // Se nenhum item for encontrado, exibir uma mensagem ou realizar outra ação
    console.log("Item não encontrado");
  }

  editDialog(item: any): void {
    // console.log(item)
    const companyUsuarioLogado = this.usuarioLogado.company?.toLowerCase();
    const transportadoraItem = item.Transportadora ? item.Transportadora.toLowerCase() : item.transportadora ? item.transportadora.toLowerCase() : '';
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && transportadoraItem.includes(companyUsuarioLogado))) {
      this.item = { ...item };
      if (item.description && item.description?.includes("JSL")) {
        this.item.transportadora = "JSL"
      }
      else if (item.description && item.description?.includes("TCM")) {
        this.item.transportadora = "TCM"
      }
      else if (item.description && item.description?.includes("ARG")) {
        this.item.transportadora = "JSL"
      }
      else if (item.transportador && item.transportador?.includes("LOTS")) {
        this.item.transportadora = "LOTS"
      }
      else if (item.transportador && item.transportador?.includes("SUZAN")) {
        this.item.transportadora = "SUZAN"
      }
      else if (item.Transportadora) {
        this.item.transportadora = item.Transportadora
      }
      else {
        this.item.transportadora = "Sem registro"
      }
      for (let i = 1; i <= 4; i++) {
        this.item["Fornecedor" + i] = item["Fornecedor " + i];
        const dataHoraString = item["Janela " + i];
        if (dataHoraString) { // Verifica se a chave existe no objeto
          const dataString = dataHoraString.slice(0, 10); // "2024-04-23"
          const horaString = dataHoraString.slice(11, 16); // "00:00"
          this.item["dataJanela" + i] = dataString;
          this.item["horaJanela" + i] = horaString;
        }
      }
      for (let i = 1; i <= 4; i++) {
        this.item["Destino" + i] = item["Destino " + i];
        const dataHoraString = item["JanelaDestino " + i];
        if (dataHoraString) { // Verifica se a chave existe no objeto
          const dataString = dataHoraString.slice(0, 10); // "2024-04-23"
          const horaString = dataHoraString.slice(11, 16); // "00:00"
          this.item["dataJanelaDestino" + i] = dataString;
          this.item["horaJanelaDestino" + i] = horaString;
        }
      }
      this.dialogOpen = true;
    } else {
      const confirmacao = window.confirm("Usuário não autorizado!");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.dialogOpen = false;
      }
    }
  }

  cancel(): void {
    this.edit2 = false;
    this.dialogOpen = false;
  }

  async salvar() {
    for (let i = 1; i <= 4; i++) {
      if (this.item["dataJanela" + i]) {
        this.item["Janela " + i] = `${this.item["dataJanela" + i]}T${this.item["horaJanela" + i]}:00.000Z`;
      }
    }
    for (let i = 1; i <= 4; i++) {
      if (this.item["dataJanelaDestino" + i]) {
        this.item["JanelaDestino " + i] = `${this.item["dataJanelaDestino" + i]}T${this.item["horaJanelaDestino" + i]}:00.000Z`;
      }
    }
    this.isLoading = true;
    this.item = {
      ...this.item,
      "ID": this.item.IdTrip,
      "lastUpdate": new Date(),
    }
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    // console.log(jsonArray)
    await this.dynamodbService.salvar(jsonArray, this.item.tableName, this.urlAtualiza).subscribe(async response => {
      // console.log(response)
      await this.update();
      this.edit2 = false;
      this.dialogOpen = false;
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
  }

  async encontrarNextPoint(item: any) {
    let nextPoint;
    if (item['Fornecedor 1'] && (!item['Passo Fornecedor1'] || (item['Passo Fornecedor1'] != 1 && item['Passo Fornecedor1'] != 2))) {
      // console.log('Fornecedor 1')
      nextPoint = item['Fornecedor 1'];
    } else if (item['Fornecedor 2'] && (!item['Passo Fornecedor2'] || (item['Passo Fornecedor2'] != 1 && item['Passo Fornecedor2'] != 2))) {
      nextPoint = item['Fornecedor 2'];
      // console.log('Fornecedor 2')
    } else if (item['Fornecedor 3'] && (!item['Passo Fornecedor3'] || (item['Passo Fornecedor3'] != 1 && item['Passo Fornecedor3'] != 2))) {
      nextPoint = item['Fornecedor 3'];
      // console.log('Fornecedor 3')
    } else if (item['Fornecedor 4'] && (!item['Passo Fornecedor4'] || (item['Passo Fornecedor4'] != 1 && item['Passo Fornecedor4'] != 2))) {
      nextPoint = item['Fornecedor 4'];
      // console.log('Fornecedor 4')
    } else if (item['Destino 1'] && (!item['Passo Destino1'] || (item['Passo Destino1'] != 1 && item['Passo Destino1'] != 2))) {
      nextPoint = item['Destino 1'];
      // console.log('Destino 1')
    } else if (item['Destino 2'] && (!item['Passo Destino2'] || (item['Passo Destino2'] != 1 && item['Passo Destino2'] != 2))) {
      nextPoint = item['Destino 2'];
      // console.log('Destino 2')
    } else if (item['Destino 3'] && (!item['Passo Destino3'] || (item['Passo Destino3'] != 1 && item['Passo Destino3'] != 2))) {
      nextPoint = item['Destino 1'];
      // console.log('Destino 3')
    } else if (item['Destino 4'] && (!item['Passo Destino4'] || (item['Passo Destino4'] != 1 && item['Passo Destino4'] != 2))) {
      nextPoint = item['Destino 4'];
      // console.log('Destino 4')
    } else {
      nextPoint = "sem next Point"
    }
    // console.log(nextPoint);
    return nextPoint;
  }

  async calculaDistanciaAteNextPoint(item: any) {
    try {
      // console.log(item)
      // console.log(item.nextPoint)
      if (item.nextPoint != "sem next Point") {
        // console.log(item.nextPoint)
        // console.log(item)
        const destinoLocation = await this.findLocationByName(item.nextPoint, this.locais);
        console.log(destinoLocation)
        const destinoLocationNumber = this.convertItem(destinoLocation);
        const truckPosition = this.convertItemViagem(item);
        // console.log(truckPosition)
        const distance1 = await this.calcularRota([destinoLocationNumber.longitude, destinoLocationNumber.latitude], [truckPosition.longitude, truckPosition.latitude]);
        // console.log(item)
        item.prevChegada = this.adicionarSegundosAoTimestamp(distance1[1]);
        item.distanceNextPoint = distance1[0];
      } else {
        item.distanceNextPoint = 0;
      }
    } catch (error) {
      console.error('Erro ao calcular a distância:', error);
    }
  }

  async findLocationByName(name: string, locations: any[]): Promise<Location> {
    // debugger
    if (name == "LCB") {
      name = "LCB DEMARCHI"
    }
    // console.log(locations)
    return await locations.find((location: { local: string; }) => location.local === name);
  }

  async findLocationNextPoint(item: any, locations: any[]) {
    // debugger
    if (item.nextPoint == "LCB") {
      item.nextPoint = "LCB DEMARCHI"
    }
    // console.log(locations)
    item.nextPointCompleto = locations.find((location: { local: string; }) => location.local === item.nextPoint);
    // console.log(item.nextPointCompleto)
  }

  async calcularRota(startLocation: number[], endLocation: number[]): Promise<[number, number]> {
    try {
      // console.log(startLocation)
      // console.log(endLocation)
      const response: any = await (await this.dynamodbService.getRota("https://klyufov1p0.execute-api.sa-east-1.amazonaws.com/v1/POST", startLocation, endLocation)).toPromise();
      if (response.statusCode === 200) {
        const data = response.body;
        if (data) {
          const distance = data.Distance;
          const durationSeconds = data.DurationSeconds;
          return [distance, durationSeconds];
        } else {
          console.error('Data not found in the response:', data);
          return [0, 0];
        }
      } else {
        console.error('Invalid response:', response);
        return [0, 0];
      }
    } catch (error) {
      console.error('Error processing data:', error);
      return [0, 0];
    }
  }

  convertItem(item: any): any {
    // console.log(item)
    return {
      ID: item.ID,
      latitude: parseFloat(item.latitude),  // Convertendo latitude para número
      local: item.local,
      longitude: parseFloat(item.longitude),  // Convertendo longitude para número
      tableName: item.tableName
    };
  }

  convertItemViagem(item: any): any {
    // console.log(item)
    return {
      ID: item.ID,
      latitude: parseFloat(item.Latitude),  // Convertendo latitude para número
      local: item.nextPoint,
      longitude: parseFloat(item.Longitude),  // Convertendo longitude para número
      tableName: item.tableName
    };
  }

  adicionarSegundosAoTimestamp(segundos: number): Date {
    const timestampAtual = Date.now();
    const novoTimestamp = timestampAtual + (segundos * 1000);
    return new Date(novoTimestamp);
  }


}
